import { ReactElement } from "react"
import { InspectorPanelKeyValueDropdown } from "./InspectorPanelKeyValueDropdown"
import classNames from "classnames"

type Child = ReactElement<typeof InspectorPanelKeyValueDropdown> | boolean
export const InspectorPanelSettingsFields = ({
    children,
    shouldShowTopBorder = true,
}: {
    children: Child | Child[]
    shouldShowTopBorder?: boolean
}) => {
    return (
        <div
            className={classNames("px-4 flex flex-col mb-2 pt-2", {
                "border-t border-t-gray-700": shouldShowTopBorder,
            })}
        >
            {children}
        </div>
    )
}
